/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBranchServiceUpdateInput } from "../../entities/models/BranchServiceUpdateInput";
import { z } from "zod/v4";

export const modelsBranchServiceUpdateInputSchema = z.object({
    "discount_type": z.optional(z.enum(["percentage", "fixed"])),
"discount_value": z.optional(z.number()),
"duration_minutes": z.optional(z.int()),
"is_active": z.optional(z.boolean()),
"price": z.optional(z.number())
    }) as unknown as z.ZodType<ModelsBranchServiceUpdateInput>